module.exports = __webpack_public_path__ + "img/algorand-logo.25e6b9cd.svg";